import React, { useState, useEffect } from "react";
import { Form, Input } from "antd";
import TagInput from "antd-tag-input";
import "antd-tag-input/dist/style.css";
import { phoneRegex } from "../../core/Utility";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import "./BasicInformation.scss";

const BasicInformation = ({ allTagsValues, getAllTagsFunc, child }: any) => {
  const [value, setValue] = useState<string[]>([]);
  const [phoneError, setPhoneError] = useState(false);
  const [phoneReceptionError, setPhoneReceptionError] = useState(false);

  useEffect(() => {
    getAllTagsFunc(value);
  }, [value]);

  useEffect(() => {
    if (value?.length === 0 && allTagsValues?.length !== 0) {
      setValue(allTagsValues);
    }
  }, [allTagsValues]);

  return (
    <div className="basic-informations">
      <Form.Item
        name="name"
        label="Naziv smeštaja:"
        rules={[
          {
            required: true,
            message: "Potrebno je uneti naziv smeštaja!",
          },
        ]}
      >
        <Input className="input-label" placeholder="Unesite naziv smeštaja" />
      </Form.Item>
      <Form.Item
        name="address"
        label="Adresa smeštaja:"
        rules={[
          {
            required: true,
            message: "Potrebno je uneti adresu smeštaja!",
          },
        ]}
      >
        <Input className="input-label" placeholder="Unesite adresu smeštaja" />
      </Form.Item>
      <Form.Item name="webAddress" label="Web prezentacija:">
        <Input className="input-label" placeholder="Unesite web prezentaciju" />
      </Form.Item>
      <Form.Item
        name="contactName"
        label="Kontakt osoba:"
        rules={[
          {
            required: true,
            message: "Potrebno je uneti kontakt osobu!",
          },
        ]}
      >
        <Input className="input-label" placeholder="Unesite kontakt osobu" />
      </Form.Item>
      <div className="phone-input-container">
        <Form.Item
          name="contactPhone"
          label="Kontakt telefon:"
          rules={[
            {
              required: true,
              message: "",
            },
            {
              validateTrigger: "onChange",
              validator: async (_, value) => {
                if (value === undefined || value === null) {
                  return setPhoneError(true);
                } else {
                  if (!phoneRegex.test(value)) {
                    setPhoneError(true);
                    return Promise.reject();
                  } else {
                    setPhoneError(false);
                    return Promise.resolve();
                  }
                }
              },
            },
          ]}
        >
          <PhoneInput
            placeholder="Unesite broj telefona"
            onChange={() => {}}
            className={phoneError ? "phone-input-error" : "phone-input"}
          />
        </Form.Item>
        {
          <p
            className={
              !phoneError ? "phone-description" : "phone-description-no-visible"
            }
          >
            Unesite ispravan format +381 66 12345678
          </p>
        }
      </div>
      <div className="phone-input-container">
        <Form.Item
          name="receptionContactPhone"
          label="Kontakt telefon recepcije:"
          rules={[
            {
              required: true,
              message: "",
            },
            {
              validateTrigger: "onChange",
              validator: async (_, value) => {
                if (value === undefined || value === null) {
                  return setPhoneReceptionError(true);
                } else {
                  if (!phoneRegex.test(value)) {
                    setPhoneReceptionError(true);
                    return Promise.reject();
                  } else {
                    setPhoneReceptionError(false);
                    return Promise.resolve();
                  }
                }
              },
            },
          ]}
        >
          <PhoneInput
            placeholder="Unesite broj telefona"
            onChange={() => {}}
            className={
              phoneReceptionError ? "phone-input-error" : "phone-input"
            }
          />
        </Form.Item>
        {
          <p
            className={
              !phoneReceptionError
                ? "phone-description"
                : "phone-description-no-visible"
            }
          >
            Unesite ispravan format +381 66 12345678
          </p>
        }
      </div>
      <Form.Item
        name="numberOfHalls"
        label="Broj sala za dogadjaje:"
        rules={[
          {
            required: true,
            message: "Potrebno je uneti broj sala!",
          },
        ]}
      >
        <Input
          type="number"
          className="input-label"
          placeholder="Unesite broj sala"
          min={1}
        />
      </Form.Item>
      <Form.Item
        name="hallCapacity"
        label="Kapacitet sale:"
        rules={[
          {
            required: true,
            message: "Potrebno je uneti kapacitet sale!",
          },
        ]}
      >
        <Input
          type="number"
          className="input-label"
          placeholder="Unesite kapacitet sale"
          min={1}
        />
      </Form.Item>
      <Form.Item label="Tagovi smeštaja:" className="tags-acc">
        <TagInput
          value={allTagsValues}
          placeholder="Unesite tagove za smeštaj"
          onChange={(strArr) => setValue(strArr)}
        />
      </Form.Item>
      <Form.Item
        name="totalNumberOfRooms"
        label="Ukupno soba:"
        rules={[{ required: true, message: "Potrebno je uneti broj soba!" }]}
      >
        <Input
          type="number"
          className="input-label"
          placeholder="Unesite broj soba"
          min={1}
        />
      </Form.Item>
      {child}
    </div>
  );
};

export default BasicInformation;
